import { render } from "./adSecure.vue?vue&type=template&id=6457fb39&lang=true"
import script from "./adSecure.vue?vue&type=script&lang=js"
export * from "./adSecure.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__